const API = {
  // 首页资讯请求
  // homeInfo: 'http://127.0.0.1/main.php'
  homeInfo: 'http://120.77.182.31:8083/main.php'
}

export default API ;


// WEBPACK FOOTER //
// ./src/page/http/http.api.js